<div class="p-6">
    <div class="flex items-start gap-3 mb-4">
        <div class="w-9 h-9 rounded-lg flex items-center justify-center shrink-0"
             [class]="isDestructive() ? 'bg-amber-50' : 'bg-blue-50'">
            <mat-icon class="!w-5 !h-5 !text-[20px] leading-5"
                      [class]="isDestructive() ? 'text-amber-600' : 'text-blue-600'">
                {{ isDestructive() ? 'volunteer_activism' : 'edit_note' }}
            </mat-icon>
        </div>
        <div>
            <h2 class="text-base font-semibold text-slate-900">{{ titleKey() | translate }}</h2>
            <p class="text-sm text-slate-500 mt-0.5">
                {{ data.obligation.amount | number:'1.2-2' }} {{ data.obligation.currency }}
            </p>
        </div>
    </div>

    <p class="text-sm text-slate-600 mb-4">{{ bodyKey() | translate }}</p>

    <label class="text-sm font-medium text-slate-900" for="obligation-reason">
        {{ 'obligations.reason' | translate }}
    </label>
    <div class="text-xs text-slate-500 mt-0.5 mb-2">{{ 'obligations.reasonHint' | translate }}</div>
    <textarea id="obligation-reason" rows="3"
              class="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-600"
              [ngModel]="reason()" (ngModelChange)="reason.set($event)"></textarea>

    <div class="flex justify-end gap-2 mt-5 pt-4 border-t border-slate-100">
        <jjames-button variant="ghost" (clicked)="onCancel()">{{ dismissKey() | translate }}</jjames-button>
        <jjames-button [variant]="isDestructive() ? 'warning' : 'primary'"
                       [disabled]="!canConfirm()" (clicked)="onConfirm()">
            {{ 'obligations.' + data.action + 'Confirm' | translate }}
        </jjames-button>
    </div>
</div>
